import { createReducer, on } from '@ngrx/store';
import {
  ROLE_FIND_SUCCESS,
  ROLE_FAILURE,
  ROLE_UPDATE_FORM,
  ROLE_RESET_ERROR,
  ROLE_RESET,
  ROLE_RESET_FORM,
  ROLE_FIND_ALL_SUCCESS,
  ROLE_EDIT_MODE,
  ROLE_CLEAR_STATE,
  ROLE_UPDATE_ID,
  ROLE_UPDATE_LOADING,
  ROLE_UPDATE_INMUTABLE,
  ROLE_UPDATE_FORM_VALID,
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  Rol,
  RolForm,
} from '@core/models';
import { transformRoleData } from '@core/helpers';

export interface RoleState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  roleId: string | null;
  role: Rol | null;
  roleList: Rol[] | null;
  roleForm: RolForm | null;
  roleInmutable: boolean,
  formValid: boolean,
  error: ResponseBadRequest | null;
}

export const initialState: RoleState = {
  loading: false,
  isEditing: false,
  editMode: false,
  roleId: null,
  role: null,
  roleList: null,
  roleForm: null,
  roleInmutable: false,
  formValid: false, 
  error: null,
};

export const roleReducer = createReducer(
  initialState,
  on(ROLE_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(ROLE_FIND_SUCCESS, (state, { role }) => ({ ...state, role: transformRoleData(role) })),
  on(ROLE_FIND_ALL_SUCCESS, (state, { roleList }) => ({ ...state, roleList })),
  on(ROLE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(ROLE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(ROLE_UPDATE_FORM, (state, { roleForm }) => ({ ...state, roleForm })),
  on(ROLE_UPDATE_FORM_VALID, (state, { formValid }) => ({ ...state, formValid })),
  on(ROLE_UPDATE_INMUTABLE, (state, { inmutable }) => ({ ...state, roleInmutable: inmutable })),
  on(ROLE_UPDATE_ID, (state, { roleId }) => ({ ...state, roleId })),
  on(ROLE_RESET, (state) => ({ ...state, role: null, roleId: null, roleForm: null })),
  on(ROLE_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(ROLE_RESET_FORM, (state) => ({ ...state, roleForm: null, loading: false })),
  on(ROLE_CLEAR_STATE, (state) => ({ ...state, ...initialState, loading: state.loading })),
);